import { fetchResponse as fetchResponseV3 } from '../core/fetch-response';
import * as Storage from '../core/local-storage';
export function convertConfigV3(config, type) {
    const name = 'default';
    const globalName = 'pbjs';
    const { id, refreshTime, userIds, tags, outstream } = config;
    const bids = config[type];
    return {
        id,
        name,
        globalName,
        refreshTime,
        bids,
        userIds,
        tags,
        bundleUrl: config.prebidUrl,
        outstream,
        isCleanIOEnabled: config.useCleanIO,
        isAmazonEnabled: config.useTAM,
        isAditudeEnabled: config.useAditude,
        isOutstreamEnabled: config.useOutstream,
        boltiveId: config.boltiveId,
        analytics: config.analytics,
    };
}
function hash(obj) {
    return JSON.stringify(obj).split('').reduce((hash, char) => (hash << 5) - hash + char.charCodeAt(0), 0);
}
export function pickConfig(configs) {
    const key = 'arkjar' + hash(configs);
    const previousResult = Storage.getItem(key);
    if (previousResult)
        return JSON.parse(previousResult);
    const totalWeight = configs.reduce((acc, cfg) => acc + cfg.weight, 0);
    const randomWeight = Math.random() * totalWeight;
    let currentWeight = 0;
    for (const config of configs) {
        currentWeight += config.weight;
        if (currentWeight > randomWeight) {
            Storage.setItem(key, JSON.stringify(config));
            return config;
        }
    }
    return configs[0];
}
export function convertResponseV3(resp) {
    const { name, mcm, schain, configs } = resp;
    const pickedConfig = pickConfig(configs);
    const config = convertConfigV3(pickedConfig, 'display');
    const videoConfig = convertConfigV3(pickedConfig, 'video');
    return {
        id: pickedConfig.id,
        name,
        mcm,
        schain,
        config,
        videoConfig,
    };
}
export function getResponseV2(host) {
    // TODO: Implement caching
    return fetchResponseV3(host)
        .then(convertResponseV3);
}
